import React, { useState} from "react";
import { CheckCircleIcon, EnvelopeIcon } from '@heroicons/react/20/solid';



function ContactNotaire(args) {
    const [formMessage, setFormMessage] = useState(false);
    const [sendMessage, setSendMessage] = useState(false);
    const [formCalendar, setCalendar] = useState(false);
    const [sendCalendar, setSendCalendar] = useState(false);
    const [description, setDescription] = useState(null);
        const [nom, setNom] = useState(null);
        const [telephone, setTelephone] = useState(null);
        const [email, setEmail] = useState(null);

    //envoier
    const handleSubmitMessage = (event) => {
        event.preventDefault();

        const userData = {
            nom: event.target.nom.value,
            email: event.target.email.value,
            telephone: event.target.telephone.value,
            description:event.target.description.value,
            idNotaire:args.id,
          };
        
          // Met à jour les states
          setDescription(userData.description);
          setNom(userData.nom);
          setEmail(userData.email);
          setTelephone(userData.telephone);

          // Envoie à Zapier avec les bonnes valeurs
        sendToZapier(userData);
    };

    //on créer le message zapier
    const sendToZapier = async (data) => {
        const zapierURL = "https://hooks.zapier.com/hooks/catch/7206204/286wr9h/"; // 👈 Specify your Zapier Webhook URL here
        try {
            const response = await fetch(zapierURL, {
                method: "POST",
                mode: "cors",
                body: JSON.stringify(data)
            });
            const res = await response.json();
            console.log("Zapier success:", res);
            if(res.status === "success"){
                setSendMessage(true);
            }
        } catch (e) {
            console.log("Zapier error:", e);
        }
    };

    return (
        <>
            <div className="relative">
                {formMessage === false && formCalendar === false && (
                    <>
                        <button
                            type="button"
                            onClick={() => { setFormMessage(true); }}
                            className="flex items-center gap-4 btn-main rounded-full "
                        >
                            <EnvelopeIcon aria-hidden="true" className="-mr-0.5 size-6" />
                            Envoyer un message à Maître {args.nom}

                        </button>

                    {/**
                        {args.abonnement === "49" && <>
                            <button
                                type="button"
                                onClick={() => { setCalendar(true); }}
                                className="mt-4 flex items-center gap-4 rounded-full bg-white px-2.5 py-2 text-base font-semibold text-gray-900 shadow-xs ring-1 ring-gray-300 ring-inset hover:bg-indigo-800"
                            >
                                <CalendarDateRangeIcon aria-hidden="true" className="-mr-0.5 size-6" />
                                Prendre rendez-vous avec Maître {args.nom}

                            </button>
                        </>}
                         */}
                    </>)}

                {formMessage === true && <>
                    {!sendMessage ? (
                        <>
                    <form action="#" method="POST" className="w-full space-y-6" onSubmit={handleSubmitMessage}>

                        <div>
                            <label className="block text-base font-medium text-gray-900"> Quel est votre besoin ?<sup>*</sup></label>
                            <textarea
                                id="description"
                                name="description"
                                rows={4}
                                minLength={50}
                                placeholder="Afin d'obtenir une réponse adaptée, merci de décrire votre situation, état d'avancement, démarches déjà engagés....etc"
                                className="input-clotere block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                                defaultValue={''}
                            />
                        </div>
                        <div>
                            <label className="block text-base font-medium text-gray-900"> Votre Nom et Prénom<sup>*</sup></label>
                            <input
                                required
                                name="nom"
                                type="text"
                                className="input-clotere"
                            />
                        </div>
                        <div>
                            <label className="block text-base font-medium text-gray-900">
                                Votre Email<sup>*</sup>
                            </label>
                            <div className="mt-2">
                                <input
                                    required
                                    name="email"
                                    type="email"
                                    className="input-clotere"
                                />
                            </div>
                        </div>
                        <div>
                            <label className="block text-base font-medium text-gray-900">
                                Votre Téléphone<sup>*</sup>
                            </label>
                            <div className="mt-2">
                                <input
                                    required
                                    name="telephone"
                                    type="text"
                                    className="input-clotere"
                                />
                            </div>
                        </div>
                        <div>
                            <button
                                type="submit"
                                className="btn-indigo no-underline p-3"
                            >
                                Envoyer votre message
                            </button>
                        </div>
                    </form>
                    </>
                ) : (
                    <>
                     <div className="rounded-md bg-green-50 p-4">
                        <div className="flex items-center">
                            <div className="shrink-0">
                            <CheckCircleIcon aria-hidden="true" className="size-6 text-green-400" />
                            </div>
                            <div className="ml-3">
                            <h3 className="text-lg mb-0 font-medium text-green-800">Votre message a bien été envoyé</h3>
                            </div>
                        </div>
                        </div>
                    </>
                )}
                </>}

                {formCalendar === true && <>
                    Prendre rendez-vous
                </>}
            </div>
        </>
    );
}

export default ContactNotaire;

